import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import '../../../assets/css/views/activities/activities.css';
import BackButton from "../../../features/path/backButton";
import { IActivityDto } from "../../../models/dto/agendaApi/IActivityDto";
import activitiesService from "../../../services/agendaApi/activities.service";
import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import activitiesIcons from "../../../utils/maps/activitiesIcons";
import { ProgressIndicator, SelectOption, Modal, Button, IconCamera, IconRestore, Select, IconWarning } from "@veneer/core";
import activitiesRoutes from "../../../utils/maps/activitiesRoutes";
import { BreadCrumbsEnum } from "../../../models/enum/BreadCrumbsEnum";
import { decryptText } from "../../../utils/encryptionUtils";
import { CountryEnum } from "../../../models/enum/CountryEnum";
import { useLocalization } from "../../../hooks/checkInOutHooks/useLocalization";
import { useCamera } from "../../../hooks/checkInOutHooks/useCamera";
import Webcam from "react-webcam";
import LoaderModal from "../../../components/Loader/loaderModal";
import checkInOutService from "../../../services/generalApi/checkInOut.service";
import MapWithPolygon from "../../../components/CheckInOut/mapWithPolygon";
import { ICheckInOutIn } from "../../../models/input/generalApi/ICheckInOutIn";
import { ActivitiesEnum } from "../../../models/enum/ActivitiesEnum";



interface ICommentDto {
  comment: string;
  typeCheck: string;
}

export default function ActivitiesByAppointment() {
  const params = useParams();
  const [t] = useTranslation("global");
  const [activities, setActivities] = useState<IActivityDto[]>([])
  const navigate = useNavigate();
  const [showLoading, setShowLoading] = useState(false);
  const [appointmentId, setAppointmentId] = useState(0);
  const languageId: any = useSelector((state: RootState) => state.languageId);
  const state: any = useSelector((state: RootState) => state.user);
  const [country, setCountry] = useState(NaN);
  type SelectValue = number | string | boolean;

  const location = useLocation();
  const { agendaSelected } = location.state;


  const [comments, setComments] = useState<SelectOption[]>([]);
  const [comment, setComment] = useState<SelectValue[]>([]);
  const [tabCheckOut, setTabCheckOut] = useState<number>(0);


  const [showModalAgendaCheckOut, setShowModalAgendaCheckOut] = useState<boolean>(false);

  const {
    geolocationState,
    checkDistance,
    latlng
  } = useLocalization();



  const {
    webcamRef,
    imgSrc,
    setImgSrc,
    chargingPhoto,
    setChargingPhoto,
    photoSaved,
    setPhotoSaved,
    photoUrl,
    setPhotoUrl,
    photoError,
    setPhotoError,
    capture,
    cleanCapture
  } = useCamera('CheckOut/');


  useEffect(() => {
    setShowLoading(true);
    let id = Number(params.id);
    setAppointmentId(id);
    setCountry(Number(decryptText(state.user.countryId)))
  }, []);

  useEffect(() => {
    if (appointmentId > 0 && languageId.value > 0) {
      getActivities();
    }
  }, [languageId, appointmentId])

  const getComments = async (subregionId: number) => {
    try {
      const response = await checkInOutService.getComments(subregionId, languageId.value, 'Check In');
      return response;
    } catch (error) {
      console.error(error);
    }
  }

  const fillComments = (data: ICommentDto[]) => {
    const commentsTemp: SelectOption[] = [];
    for (let i = 0; i < data.length; i++) {
      const comment: ICommentDto = data[i];
      let commentTemp: SelectOption;
      commentTemp = {
        'value': i,
        'label': comment.comment,
      }
      commentsTemp.push(commentTemp);
    }
    setComments(commentsTemp);
    setComment([commentsTemp[0].value])
  }

  const getActivities = () => {
    activitiesService.getActivitiesByAppointmentCheckIn(appointmentId, languageId.value)
      .then((r: IActivityDto[]) => {
        let responseSort;
        if (agendaSelected.checkOutDatetime !== null) {
          responseSort = r.sort((a: any, b: any) => a.id - b.id).filter(activity => activity.activityID !== ActivitiesEnum.CheckOut);
        } else {
          responseSort = r.sort((a: any, b: any) => a.id - b.id);
        }

        if (country === CountryEnum.brasil1 || country === CountryEnum.brasil2 || country === CountryEnum.brasil3) {
          setActivities(responseSort.filter(activity => activity.activityID != 14 && activity.activityID != 18));
        } else if (country === CountryEnum.colombia1 || country === CountryEnum.colombia2 || country === CountryEnum.colombia3) {
          setActivities(responseSort.filter(activity => activity.activityID != 3 && activity.activityID != 9 && activity.activityID != 18));
        } else {
          setActivities(responseSort.filter(activity => activity.activityID != 3 && activity.activityID != 9 && activity.activityID != 14 && activity.activityID != 18));
        }
      }).finally(() => {
        setShowLoading(false)
      })
  }


  const goToActivity = (activityId: number, appointmentActivityID: number) => {
    if (activityId === ActivitiesEnum.CheckOut) {
      handleCheckOut()
    } else {
      navigate(`/${activitiesRoutes.get(activityId)}/${appointmentActivityID}/${appointmentId}`);
    }
  }


  const handleCloseCheckOut = () => {
    setShowModalAgendaCheckOut(false)
    cleanCapture();
    setComment([]);
    setComments([]);
    setTabCheckOut(0);
  }

  const handleChangeComment = (value: SelectValue) => {
    setComment([value])
  }

  const handleCheckOut = () => {
    getComments(agendaSelected!.subRegionId).then((res: ICommentDto[]) => {
      fillComments(res);
    }).finally(() => setShowModalAgendaCheckOut(true));
  }

  const onCheckOut = () => {
    setChargingPhoto(true);
    let checkOut: ICheckInOutIn = {
      appointmentID: agendaSelected!.appointmentId,
      activityID: 5, //1 Check In - 5 Check Out
      longitude: latlng[1],
      latitude: latlng[0],
      checkStatus: 3,
      locPhoto: photoUrl!,
      photo: 'N/A',
      comments: String(comments.find(item => item.value === comment[0])?.label ?? t("header.comments"))
    };
    try {
      checkInOutService.postCheckInOut(checkOut)
        .then(r => {
          setChargingPhoto(false);
          setShowModalAgendaCheckOut(false);
          cleanCapture();
          setComment([]);
          setComments([]);
          setTabCheckOut(0);
          navigate(`/agendas`);
        })

    } catch (error) {
      setShowModalAgendaCheckOut(false);
      setChargingPhoto(false);
      setTabCheckOut(0);

    }
  }

  return (
    <div>
      <div style={{ padding: '20px' }}>
        <BackButton route={BreadCrumbsEnum.Activities} activityId={appointmentId} />
        <h4>{t("header.activities")}</h4>
        <div style={{ padding: '20px' }}>
          {showLoading ?
            <div className="container">
              <div className="vertical-center">
                <ProgressIndicator
                  appearance="circular"
                  behavior="indeterminate"
                />
              </div>
            </div>
            :
            <div id="container">
              <div id="inner">
                {
                  activities.map(activity =>
                    <div key={activity.activityID} className="child" onClick={() => goToActivity(activity.activityID, activity.appointmentActivityID)}>
                      <div className="square" style={{ border: `3px solid #${activity.activityColor}`, textAlign: 'center' }}>
                        <div style={{ margin: '10px' }}>
                          <div style={{ textAlign: 'center' }}>
                            <h6 style={{ height: "auto" }}>{activity.activityName}</h6>
                          </div>
                          <div style={{ margin: '15px' }}>
                            {activitiesIcons?.get(activity.activityID)}
                          </div>
                          <div style={{ textAlign: 'right' }}>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }
              </div>
            </div>
          }
        </div>
      </div>

      <div style={{ position: 'relative' }}>
        <Modal
          className="modalAgendaCheckOut"
          align="center"
          id="modalAgendaCheckOut"
          show={showModalAgendaCheckOut}
          closeButton
          onClose={handleCloseCheckOut}
          footer={(() => {
            switch (tabCheckOut) {
              case 0:
                return <Button disabled={!photoSaved} onClick={() => setTabCheckOut(1)}>{t("header.next")}</Button>
                break;
              case 1:
                return <Button disabled={!photoSaved} onClick={() => onCheckOut()}>{t("header.checkOut")}</Button>
                break;
              default:
                <p>{t("header.error")}</p>
            }
          })()
          }
          title={t("header.checkOut")}
        >
          {agendaSelected && checkDistance(agendaSelected.latitude, agendaSelected.longitude, agendaSelected.latitude, agendaSelected.longitude) ?
            <div>
              {(() => {
                if (tabCheckOut === 0) {
                  return (<>
                    {chargingPhoto && <LoaderModal />}
                    {showModalAgendaCheckOut && (imgSrc ? <img src={imgSrc} alt="Captured" style={{ width: '100%', borderRadius: '12px' }} /> :
                      <Webcam audio={false} ref={webcamRef} style={{ width: '100%', borderRadius: '12px' }} />
                    )}
                    {photoError && <p style={{ color: 'red' }}>{t("header.error")}</p>}
                    <Button disabled={!photoSaved} onClick={cleanCapture} appearance="secondary" leadingIcon={<IconRestore />} style={{ marginRight: '2px' }} />
                    <Button disabled={photoSaved} onClick={capture} leadingIcon={<IconCamera />} />

                    <Select
                      className="modalAgendaCheckInSelect"
                      label={t("header.comments")}
                      onChange={e => handleChangeComment(e.value)}
                      options={comments}
                      value={comment}
                      clearIcon={false}
                    />
                  </>

                  )
                }
                else if (tabCheckOut === 1) {
                  return (<div className="modalAgendaDivMap">
                    <MapWithPolygon latPoint={agendaSelected.latitude} lngPoint={agendaSelected.longitude} lat={latlng[0]} lng={latlng[1]} />
                  </div>)
                }

              })()}

            </div>
            :
            <div>
              <IconWarning size={120} />
              <br />
              <b>{t("header.errorGeolocalizationDistance")}</b>
            </div>
          }
        </Modal>
      </div>

    </div>
  );
}